import { useQuery } from "@tanstack/react-query";
import { UserService } from "services";

export const useUsers = () => {
	const { data: users } = useQuery({
		queryKey: ['users'],
		queryFn: UserService.getAll
	})

    return {
        users
    };
}